import Icon from "@ant-design/icons";

const UpDownIconSVG = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.96666 4.97998C6.83999 4.97998 6.7133 4.93333 6.6133 4.83333L4.48663 2.70667L2.35997 4.83333C2.16663 5.02667 1.84663 5.02667 1.6533 4.83333C1.45997 4.64 1.45997 4.32 1.6533 4.12667L4.13332 1.64665C4.22666 1.55331 4.3533 1.5 4.48663 1.5C4.61997 1.5 4.74665 1.55331 4.83999 1.64665L7.31997 4.12667C7.5133 4.32 7.5133 4.64 7.31997 4.83333C7.21997 4.93333 7.09332 4.97998 6.96666 4.97998Z"
      fill="#9A8EA4"
    />
    <path
      d="M4.48633 14.5C4.21299 14.5 3.98633 14.2733 3.98633 14V2C3.98633 1.72667 4.21299 1.5 4.48633 1.5C4.75966 1.5 4.98633 1.72667 4.98633 2V14C4.98633 14.2733 4.75966 14.5 4.48633 14.5Z"
      fill="#9A8EA4"
    />
    <path
      d="M11.5198 14.5001C11.3865 14.5001 11.2598 14.4467 11.1665 14.3534L8.6865 11.8734C8.49317 11.6801 8.49317 11.3601 8.6865 11.1667C8.87984 10.9734 9.19984 10.9734 9.39317 11.1667L11.5198 13.2934L13.6465 11.1667C13.8398 10.9734 14.1598 10.9734 14.3532 11.1667C14.5465 11.3601 14.5465 11.6801 14.3532 11.8734L11.8731 14.3534C11.7798 14.4467 11.6465 14.5001 11.5198 14.5001Z"
      fill="#9A8EA4"
    />
    <path
      d="M11.5137 14.5C11.2403 14.5 11.0137 14.2733 11.0137 14V2C11.0137 1.72667 11.2403 1.5 11.5137 1.5C11.787 1.5 12.0137 1.72667 12.0137 2V14C12.0137 14.2733 11.7937 14.5 11.5137 14.5Z"
      fill="#9A8EA4"
    />
  </svg>
);
const UpDownIcon = (props) => (
  <Icon component={() => UpDownIconSVG(props)} {...props} />
);

export default UpDownIcon;
